export default __webpack_public_path__ + "static/media/wippy_download_page_text_zh.ef11d48c.svg";